import * as Yup from 'yup';
export const buildValidationSchema = (settingsJson: any[]) => {
  const shape: Record<string, any> = {};
  settingsJson.forEach((row: any) => {
    row.cols.forEach((col: any) => {
      let schema;

      // Set schema type based on `validate`
      switch (col.validate) {
        case 'email':
          schema = Yup.string().email(`${col.label} must be a valid email`);
          break;
        case 'number':
          schema = Yup.number()
            .typeError(`${col.label} must be a number`);
          break;
        case 'string':
        default:
          schema = Yup.string();
          break;
      }

      // Handle `required`
      if (col.required) {
        schema = schema.required(`${col.label} is required`);
      }

      shape[col.name] = schema;
    });
  });

  return Yup.object().shape(shape);
};
